webpackJsonp([15],{

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getKnowledgeList;
/* harmony export (immutable) */ __webpack_exports__["b"] = getKLByProblemGuid;
/* harmony export (immutable) */ __webpack_exports__["e"] = addNewKnowledge;
/* harmony export (immutable) */ __webpack_exports__["f"] = getKnowledgeByGuid;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateKnowledgeByGuid;
/* harmony export (immutable) */ __webpack_exports__["c"] = weixintest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__(13);


function getKnowledgeList(keywords) {
  console.log('-------api-getKnowledgeList---');
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getKnowledgeList',
    params: {
      keywords: keywords
    },
    method: 'get'
  });
}

function getKLByProblemGuid(pguid) {
  console.log('-------api-getKLByProblemGuid---pguid==' + pguid);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getKLByProblemGuid',
    params: {
      pguid: pguid
    },
    method: 'get'
  });
}

function addNewKnowledge(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/addNewKnowledge',
    data: data,
    method: 'post'
  });
}

function getKnowledgeByGuid(kguid) {
  console.log('-------api-getKnowledgeByGuid---');
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getKnowledgeByGuidManager',
    params: {
      kguid: kguid
    },
    method: 'get'
  });
}

function updateKnowledgeByGuid(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/updateKnowledgeByGuid',
    data: data,
    method: 'post'
  });
}

function weixintest(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: 'https://apitest.mch.weixin.qq.com/sandboxnew/pay/getsignkey',
    data: data,
    method: 'post'
  });
}

/***/ }),

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formatDate */
/* harmony export (immutable) */ __webpack_exports__["a"] = deBouce;
/* harmony export (immutable) */ __webpack_exports__["b"] = getUUID;
function formatDate(strTime) {
  var date = new Date(strTime);
  return date.getFullYear() + '-' + (date.getMonth() + 1).toString() + '-' + date.getDate();
}

function deBouce(callBack, duration) {
  var t = null;
  if (t) {
    window.clearTimeout(t);
  }
  t = setTimeout(function () {
    if (callBack) callBack();
  }, duration);
}

var nanoid = __webpack_require__(248);
function getUUID() {
  return nanoid();
}

/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getHintList;
/* harmony export (immutable) */ __webpack_exports__["d"] = getHintByGuid;
/* harmony export (immutable) */ __webpack_exports__["b"] = addNewHint;
/* harmony export (immutable) */ __webpack_exports__["c"] = updateHintByGuid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__(13);


function getHintList(pguid) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getHintList_manager',
    params: {
      pguid: pguid
    },
    method: 'get'
  });
}

function getHintByGuid(guid) {
  console.log('guid---guid=' + guid);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getHintByGuid_manager',
    params: {
      guid: guid
    },
    method: 'get'
  });
}

function addNewHint(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/addNewHint',
    data: data,
    method: 'post'
  });
}

function updateHintByGuid(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/updateHintByGuid',
    data: data,
    method: 'post'
  });
}

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSolutionList;
/* harmony export (immutable) */ __webpack_exports__["d"] = getSolutionByGuid;
/* harmony export (immutable) */ __webpack_exports__["b"] = addNewSolution;
/* harmony export (immutable) */ __webpack_exports__["c"] = updateSolutionByGuid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__(13);


function getSolutionList(pguid) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/manager_getSolutionList',
    params: {
      pguid: pguid
    },
    method: 'get'
  });
}

function getSolutionByGuid(guid) {
  console.log('guid---guid=' + guid);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getSolutionByGuid_manager',
    params: {
      guid: guid
    },
    method: 'get'
  });
}

function addNewSolution(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/addNewSolution',
    data: data,
    method: 'post'
  });
}

function updateSolutionByGuid(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/updateSolutionByGuid',
    data: data,
    method: 'post'
  });
}

/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNewTeamList;
/* unused harmony export delTeam */
/* harmony export (immutable) */ __webpack_exports__["c"] = closeTeam;
/* harmony export (immutable) */ __webpack_exports__["b"] = openTeam;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__(13);


function getNewTeamList() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/get_new_team_list',
    params: {},
    method: 'get'
  });
}

function delTeam(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/del_team_by_guid',
    data: data,
    method: 'post'
  });
}

function closeTeam(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/close_team_by_guid',
    data: data,
    method: 'post'
  });
}

function openTeam(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/open_team_by_guid',
    data: data,
    method: 'post'
  });
}

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(57);





var service = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: "http://121.42.137.15/api",
  timeout: 15000
});

service.interceptors.request.use(function (config) {
  if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.token) {
    config.headers['math-access-token'] = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.token;
  }
  return config;
}, function (error) {
  console.log(error);
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

service.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  console.log(error);
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_USER', {
    phone: '',
    QX: 0
  });
  __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'login' });
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDshProblemList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__(13);


function getDshProblemList() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getDshProblemList',
    params: {},
    method: 'get'
  });
}

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getProblemList;
/* harmony export (immutable) */ __webpack_exports__["b"] = getProblemTotal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__(13);


function getProblemList(problemMain, problemGuid, keywords, title, qt, pageIndex, rows) {
  console.log('getProblemList----problemMain==' + problemMain);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getProblemList',
    params: {
      problemMain: problemMain,
      problemGuid: problemGuid,
      keywords: keywords,
      title: title,
      qt: qt,
      pageIndex: pageIndex,
      rows: rows
    },
    method: 'get'
  });
}

function getProblemTotal(problemMain, problemGuid, keywords, title, qt) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getProblemTotal',
    params: {
      problemMain: problemMain,
      problemGuid: problemGuid,
      keywords: keywords,
      title: title,
      qt: qt
    },
    method: 'get'
  });
}

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = login;
/* harmony export (immutable) */ __webpack_exports__["b"] = logout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__(13);


function login(phone, password) {
  var data = {
    phone: phone,
    password: password
  };
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/loginAdmin',
    method: 'post',
    data: data
  });
}

function logout() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/logoutAdmin',
    method: 'post'
  });
}

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_scroll_css__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_scroll_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_styles_scroll_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vueg_css_animate_css__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vueg_css_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vueg_css_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_default_index_css__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icon_iconfont_css__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icon_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_icon_iconfont_css__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui___default.a);

if (window.Quill) {
  __webpack_require__(59);
}

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_hint__ = __webpack_require__(103);



var state = {
  hintData: []
};

var mutations = {
  SET_SOLUTION_DATA: function SET_SOLUTION_DATA(state, data) {
    state.hintData = data;
  }
};

var actions = {
  actions_getHintList: function actions_getHintList(_ref, tmguid) {
    var commit = _ref.commit;

    console.log('actions_getHintList--tmguid=' + tmguid);
    state.hintData = [];
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_hint__["a" /* getHintList */])(tmguid).then(function (response) {
        var data = response.data;
        if (data.isOk) {
          commit('SET_SOLUTION_DATA', data.data);
          resolve();
        } else {
          reject(data.msg);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

var getters = {
  hintList: function hintList(state) {
    return state.hintData;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_knowledge__ = __webpack_require__(101);



var state = {
  knowledgeData: []
};

var mutations = {
  SET_KNOWLEDGE_DATA: function SET_KNOWLEDGE_DATA(state, data) {
    state.knowledgeData = data;
  }
};

var actions = {
  actions_getKnowledgeList: function actions_getKnowledgeList(_ref, keywords) {
    var commit = _ref.commit;

    console.log('-------actions_getKnowledgeList-------');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_knowledge__["a" /* getKnowledgeList */])(keywords).then(function (response) {
        var data = response.data;
        if (data.isOk) {
          commit('SET_KNOWLEDGE_DATA', data.data);
          resolve();
        } else {
          reject(data.msg);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  actions_getKLByProblemGuid: function actions_getKLByProblemGuid(_ref2, tmguid) {
    var commit = _ref2.commit;

    console.log('-------actions_getKnowledgeList-------tmguid=' + tmguid);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_knowledge__["b" /* getKLByProblemGuid */])(tmguid).then(function (response) {
        var data = response.data;
        if (data.isOk) {
          commit('SET_KNOWLEDGE_DATA', data.data);
          resolve();
        } else {
          reject(data.msg);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

var getters = {
  knowledgeList: function knowledgeList(state) {
    return state.knowledgeData;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_prepareProblemList__ = __webpack_require__(146);



var state = {
  dshProblemData: []
};

var mutations = {
  SET_DSH_PROBLEM_DATA: function SET_DSH_PROBLEM_DATA(state, data) {
    state.dshProblemData = data;
  }
};

var actions = {
  actions_getDshProblemList: function actions_getDshProblemList(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_prepareProblemList__["a" /* getDshProblemList */])().then(function (response) {
        var data = response.data;
        if (data.isOk) {
          commit('SET_DSH_PROBLEM_DATA', data.data);
          resolve();
        } else {
          reject(data.msg);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

var getters = {
  dshProblemList: function dshProblemList(state) {
    return state.dshProblemData;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_problemList__ = __webpack_require__(147);





var state = {
  problemData: [],
  pageIndex: 1,
  rows: 20,
  total: 20
};

var mutations = {
  SET_PROBLEM_DATA: function SET_PROBLEM_DATA(state, data) {
    state.problemData = data;
  },
  SET_PAGE_INDEX: function SET_PAGE_INDEX(state, pageIndex) {
    state.pageIndex = pageIndex;
  },
  SET_ROWS: function SET_ROWS(state, rows) {
    state.rows = rows;
  },
  SET_TOTAL: function SET_TOTAL(state, total) {
    state.total = total;
  }
};

var actions = {
  actions_getProblemList: function actions_getProblemList(_ref, _ref2) {
    var commit = _ref.commit;

    var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref2, 7),
        problemMain = _ref3[0],
        problemGuid = _ref3[1],
        keywords = _ref3[2],
        title = _ref3[3],
        qt = _ref3[4],
        pageIndex = _ref3[5],
        rows = _ref3[6];

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_api_problemList__["a" /* getProblemList */])(problemMain, problemGuid, keywords, title, qt, pageIndex, rows).then(function (response) {
        var data = response.data;
        if (data.isOk) {
          commit('SET_PROBLEM_DATA', data.data);
          resolve();
        } else {
          reject(data.msg);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  actions_getProblemTotal: function actions_getProblemTotal(_ref4, _ref5) {
    var commit = _ref4.commit;

    var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref5, 5),
        problemMain = _ref6[0],
        problemGuid = _ref6[1],
        keywords = _ref6[2],
        title = _ref6[3],
        qt = _ref6[4];

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_api_problemList__["b" /* getProblemTotal */])(problemMain, problemGuid, keywords, title, qt).then(function (response) {
        var data = response.data;
        console.log('actions_getProblemTotal->response.data=====', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
        if (data.isOk) {
          commit('SET_TOTAL', data.total);
          resolve();
        } else {
          reject(data.msg);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

var getters = {
  problemList: function problemList(state) {
    return state.problemData;
  },
  pageIndex: function pageIndex(state) {
    return state.pageIndex;
  },
  rows: function rows(state) {
    return state.rows;
  },
  total: function total(state) {
    return state.total;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_solution__ = __webpack_require__(104);



var state = {
  solutionData: []
};

var mutations = {
  SET_SOLUTION_DATA: function SET_SOLUTION_DATA(state, data) {
    state.solutionData = data;
  }
};

var actions = {
  actions_getSolutionList: function actions_getSolutionList(_ref, tmguid) {
    var commit = _ref.commit;

    console.log('actions_getSolutionList--tmguid=' + tmguid);
    state.solutionData = [];
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_solution__["a" /* getSolutionList */])(tmguid).then(function (response) {
        var data = response.data;
        if (data.isOk) {
          commit('SET_SOLUTION_DATA', data.data);
          resolve();
        } else {
          reject(data.msg);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

var getters = {
  solutionList: function solutionList(state) {
    return state.solutionData;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_team__ = __webpack_require__(105);



var state = {
  dshTeamData: []
};

var mutations = {
  SET_DSH_PROBLEM_DATA: function SET_DSH_PROBLEM_DATA(state, data) {
    state.dshTeamData = data;
  }
};

var actions = {
  actions_getNewTeamList: function actions_getNewTeamList(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_team__["a" /* getNewTeamList */])().then(function (response) {
        var data = response.data;
        if (data.isOk) {
          commit('SET_DSH_PROBLEM_DATA', data.data);
          resolve();
        } else {
          reject(data.msg);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

var getters = {
  dshTeamList: function dshTeamList(state) {
    return state.dshTeamData;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_login__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);




var state = {
  token: __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('token'),
  phone: '',
  qx: 0
};

var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },

  SET_USER: function SET_USER(state, user) {
    state.phone = user.phone;
    state.qx = user.qx;
  }
};

var actions = {
  Login: function Login(_ref, user) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_login__["a" /* login */])(user.phone, user.password).then(function (response) {
        var data = response.data;
        if (data.isOk) {
          console.log('login data=', data);
          __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('token', data.token);
          commit('SET_TOKEN', data.token);
          commit('SET_USER', data.user);
          resolve();
        } else {
          reject(data.msg);
        }
      }).catch(function (error) {
        var errMsg = error.message === 'Network Error' ? '网络错误,请检查您的网络是否连通！' : error.message;
        reject(errMsg);
      });
    });
  },
  LogOut: function LogOut(_ref2) {
    var commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_login__["b" /* logout */])().then(function () {
        commit('SET_TOKEN', '');
        commit('SET_USER', {
          PHONE: '',
          QX: 0
        });
        __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.remove('token');
        resolve();
      }).catch(function (error) {
        commit('SET_TOKEN', '');
        commit('SET_USER', {
          PHONE: '',
          QX: 0
        });
        __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.remove('token');
        reject(error);
      });
    });
  }
};

var getters = {
  phone: function phone(state) {
    return state.phone;
  },
  bm: function bm(state) {
    return state.bm;
  },
  token: function token(state) {
    return state.token;
  },
  qx: function qx(state) {
    return state.qx;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(102);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('resize', function () {
      _this.resizeWindow();
    });
    this.resizeWindow();
  },

  methods: {
    logoutReq: function logoutReq() {
      var _this2 = this;

      this.$confirm('此操作将退出该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.logout();
      }).catch(function () {
        console.log('cancel logout.');
      });
    },
    logout: function logout() {
      var _this3 = this;

      this.$store.dispatch('LogOut').then(function () {
        _this3.$router.push({ name: 'login' });
      }).catch(function (err) {
        console.log(err);
      });
    },
    resizeWindow: function resizeWindow() {
      var _this4 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* deBouce */])(function () {
        var winHeight = document.body.offsetHeight;
        _this4.$store.dispatch('SetWinHeight', winHeight);
      }, 500);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['phone']))
});

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wBDAAcFBQYFBAcGBQYIBwcIChELCgkJChUPEAwRGBUaGRgVGBcbHichGx0lHRcYIi4iJSgpKywrGiAvMy8qMicqKyr/2wBDAQcICAoJChQLCxQqHBgcKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKir/wAARCADIAMgDASIAAhEBAxEB/8QAHAABAAMBAQEBAQAAAAAAAAAAAAQFBgMCAQcI/8QAQBAAAgECAgMKCwgCAwEAAAAAAAECAwQFEQYSIRMiMTVBUWFxstEUI1JTc4GCkbHB8BUWMlRioaPhY6I0QkOS/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwD+kQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfG1FZt5JcrI1TErKk9/c08+h5/ACUCD9tYfnl4Qv8A4l3HSniVnVeULmnn0vL4gSgfE1JZp5p8qPoAAAAAAAAAAAAAAAAAAAAAAAOdxXp21CVWtLVjH9wPU5wpwc6klGMdrbfAUl7pDk3Cyjn/AJJL4IrcQxKrf1N89WkvwwXz6SGFda91XuZZ16sp9b2L1HIAAAAOtC6r20s6FWUOp7H6i5stIc2oXscv8kV8UUIA3MJwqQU6clKLWaafCejIYfiVWwqb161J/ig/l0mrt69O5oRq0Za0ZBHQAAAAAAAAAAAAAAAAAADKYviDvbnVg/E03lHp6S5xy78GsHCDynV3q6uX66TLBQAAAAAAAAAACfhGIOyudWb8TN5SXN0kAAbsFbgd34TYKEnnOlvX1cn10FkEAAAAAAAAAAAAAAAAZjSCtumI7nyU4pet7e4qyTiUtfE7hvzjXu2EYKAAAAAAAAAAAAALTR+tueI7nyVYtetbe805jcNlqYnbtecS9+w2QQAAAAAAAAAAAAAAABjMQWriVwn52T/cjlhjlLcsVm+SaUl8PkV4UAAAAAAAAAAAAASMPWtiVul52L/c2ZlMDpbrisHyQTk/h8zVgAAEAAAAAAAAAAAAAFPpDaupbQuIrbTeUup/38TOG5qU41acqc1nGSyaMbfWk7K6lSntXDF86CuAAAAAAAAAAAAHextJ3t1GlDYuGT5kBeaPWrp207iS21HlHqX9/AuDzTpxpU404LKMVkkeggAAAAAAAAAAAAAAAARMRsIX9vqS3s47YS5n3EsAYevQqW1aVKtFxkjwbO8saN9S1K0dq/DJcMTN3uD3No3JR3Wn5UVwdaCoAAAAAAAT7LB7m7ak47lT8qS4epAQ6FCpc1o0qMXKbNbh1hCwt9RZSnLbOXO+492djRsaWpRjtf4pPhZICAAAAAAAAAAAAAAAUWk2JStreNrRllOss5NcKj/YDEtJqVtN0rOKrVFscm96u8p56SYnKWca0YdEaa+ZVACy+8OKfmv449w+8OKfmv449xWgC/scav60JbpXzafkR7iV9qXnnv8AVdxR4bLxk486z+veWIHuc43FaMrmEZLPfOMVFv1ony0dtqkVKhXmoy2rPJlaS7PEatqtTLXh5L5OoDp92Vn/AMvZ6P8As6U9HLeO2rWqS6skXCbaTayfMU2JX9bdZ28VqRWx5cMgIcpU7a6k7KMYxi8oylFSfXmzr9qXnnv9V3EQAfb7Gr+jCO518m35Ee4hfeHFPzX8ce45YlLxkI8yz+vcQgLL7w4p+a/jj3HqOkeJxebuFLodOPcVYA1FhpTGpNU7+mqef/pDg9aNDGSlFSi001mmnsZ+bGk0XxKTm7GrLNZOVPPk518wNMAAAAAAAAYrSSbljlVP/pGKXuT+ZtTD6Q8fXHs9lAVoAAAACRYy1buK500WxS0JatxTf6kXQAkWFLdr6lHLYnm/VtI5aYJSznUqtcC1V9e4C4KTGaWrdRqLgnH919IuyBjFLXs1NcMJZ+p7O4CiAAFTfS1ruS5kkRzpcS1rio/1M5gAAAJeFTdPF7Vx5asY+95fMiEnDeNbT08O0gP0EAAAAAAAAw+kPH1x7PZRuDD6Q8fXHs9lAVoAAAAAnk80XsXrRTXKsyiLm2lrWtN/pyA6mhwyluVhDnlvn6/6yM/COvUjFvLNpZvkNVFKMVFbElkgPpzuKe7W9Sn5UWkdABk+s+SerFt8izO97BU72rGLTWs+AiXMtW1qP9OQFM3m82AAAAAEnDeNbT08O0iMScN41tPTw7SA/QQAAAAAAADD6Q8fXHs9lG4MPpDx9cez2UBWgAAAABaYfLO1y8ltFWT8NlvakebJgTy+wu78IobnN+Mp7H0rnKE6W1eVtXjUhycK50BqCJiF2rWhvX4yWyK+Z38Ip+DbvreLy1szO3VxK6ryqS2LgS5kBxbzbb2si4hLK1y8ppEog4lLe049LYFeAAAAAEnDeNbT08O0iMScN41tPTw7SA/QQAAAAAAADD6Q8fXHs9lAAVoAAAAAS8OllcNc8QALMAAdN3qeD7hreLz1sjmAAKzEZZ3CXNEACIAAAAAEnDeNbT08O0gAP0EAAAAB/9k="

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('span', [_vm._v("数学长征")]), _vm._v(" "), (_vm.phone) ? _c('div', {
    staticClass: "headerBtn"
  }, [_c('div', {
    staticClass: "user"
  }, [_c('img', {
    staticStyle: {
      "width": "32px",
      "height": "32px"
    },
    attrs: {
      "src": __webpack_require__(249)
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "padding": "0 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.phone))])]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "系统设置",
      "placement": "bottom"
    }
  }, [_c('span', {
    staticClass: "tool"
  }, [_c('i', {
    staticClass: "iconfont icon-xitongshezhi"
  })])]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "帮助",
      "placement": "bottom"
    }
  }, [_c('span', {
    staticClass: "tool"
  }, [_c('i', {
    staticClass: "iconfont icon-bangzhu"
  })])]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "退出",
      "placement": "bottom"
    }
  }, [_c('span', {
    staticClass: "tool",
    on: {
      "click": _vm.logoutReq
    }
  }, [_c('i', {
    staticClass: "iconfont icon-loginout"
  })])])], 1) : _vm._e()]), _vm._v(" "), _c('main', [_c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "animated fadeInLeft",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [_c('router-view', {
    staticClass: "router"
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_user__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_prepareProblemListData_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_problemListData_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_solutionListData_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_knowledgeListData_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_hintListData_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_teamListData_js__ = __webpack_require__(155);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var state = {
  winHeight: 1000
};

var mutations = {
  SET_WIN_HEIGHT: function SET_WIN_HEIGHT(state, h) {
    state.winHeight = h;
  }
};

var actions = {
  SetWinHeight: function SetWinHeight(_ref, h) {
    var commit = _ref.commit;

    commit('SET_WIN_HEIGHT', h);
  }
};

var getters = {};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__modules_user__["a" /* default */],
    preProblem: __WEBPACK_IMPORTED_MODULE_3__modules_prepareProblemListData_js__["a" /* default */],
    problemList: __WEBPACK_IMPORTED_MODULE_4__modules_problemListData_js__["a" /* default */],
    solutionList: __WEBPACK_IMPORTED_MODULE_5__modules_solutionListData_js__["a" /* default */],
    knowledgeList: __WEBPACK_IMPORTED_MODULE_6__modules_knowledgeListData_js__["a" /* default */],
    hintList: __WEBPACK_IMPORTED_MODULE_7__modules_hintListData_js__["a" /* default */],
    teamList: __WEBPACK_IMPORTED_MODULE_8__modules_teamListData_js__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(251);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var login = function login(r) {
  return __webpack_require__.e/* require.ensure */(11).then((function () {
    return r(__webpack_require__(260));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var home = function home(r) {
  return __webpack_require__.e/* require.ensure */(12).then((function () {
    return r(__webpack_require__(258));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var welcome = function welcome(r) {
  return __webpack_require__.e/* require.ensure */(8).then((function () {
    return r(__webpack_require__(268));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var createProblem = function createProblem(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(255));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var fhcreateProblem = function fhcreateProblem(r) {
  return __webpack_require__.e/* require.ensure */(7).then((function () {
    return r(__webpack_require__(257));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var examine = function examine(r) {
  return __webpack_require__.e/* require.ensure */(13).then((function () {
    return r(__webpack_require__(256));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var problemList = function problemList(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__(266));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var prepareProblemList = function prepareProblemList(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__(264));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var prepareProblemListUser = function prepareProblemListUser(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__(265));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var knowledgeList = function knowledgeList(r) {
  return __webpack_require__.e/* require.ensure */(5).then((function () {
    return r(__webpack_require__(259));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var managerPage = function managerPage(r) {
  return __webpack_require__.e/* require.ensure */(10).then((function () {
    return r(__webpack_require__(261));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var noticePage = function noticePage(r) {
  return __webpack_require__.e/* require.ensure */(9).then((function () {
    return r(__webpack_require__(263));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var upload2Oss = function upload2Oss(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(267));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var newTeamList = function newTeamList(r) {
  return __webpack_require__.e/* require.ensure */(6).then((function () {
    return r(__webpack_require__(262));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'login',
    component: login
  }, {
    path: '/home',
    name: 'home',
    component: home,
    redirect: { name: 'welcome' },
    children: [{
      path: 'welcome',
      name: 'welcome',
      component: welcome
    }, {
      path: 'createProblem',
      name: 'CreateProblem',
      component: createProblem
    }, {
      path: 'fhcreateProblem',
      name: 'fhCreateProblem',
      component: fhcreateProblem
    }, {
      path: 'examine',
      name: 'examine',
      component: examine
    }, {
      path: 'problemList',
      name: 'problemList',
      component: problemList
    }, {
      path: 'prepareProblemList',
      name: 'prepareProblemList',
      component: prepareProblemList
    }, {
      path: 'newTeamList',
      name: 'newTeamList',
      component: newTeamList
    }, {
      path: 'prepareProblemListUser',
      name: 'prepareProblemListUser',
      component: prepareProblemListUser
    }, {
      path: 'knowledgeList',
      name: 'knowledgeList',
      component: knowledgeList
    }, {
      path: 'managerPage',
      name: 'managerPage',
      component: managerPage
    }, {
      path: 'noticePage',
      name: 'noticePage',
      component: noticePage
    }, {
      path: 'upload2Oss',
      name: 'upload2Oss',
      component: upload2Oss
    }]
  }, { path: '*', redirect: '/' }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["setEditor"] = setEditor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);








var Container = window.Quill.import('blots/container');
var Scroll = window.Quill.import('blots/scroll');
var Block = window.Quill.import('blots/block');
var Parchment = window.Quill.import('parchment');
var BlockEmbed = window.Quill.import('blots/block/embed');
var quill = null;

function setEditor(editor) {
  quill = editor;
}

var ContainBlot = function (_Container) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(ContainBlot, _Container);

  function ContainBlot() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ContainBlot);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ContainBlot.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ContainBlot)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ContainBlot, [{
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      if (blot.statics.blotName === this.statics.blotName) {
        __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(ContainBlot.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ContainBlot.prototype), 'insertBefore', this).call(this, blot.children.head, ref);
      } else {
        __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(ContainBlot.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ContainBlot.prototype), 'insertBefore', this).call(this, blot, ref);
      }
    }
  }, {
    key: 'formats',
    value: function formats() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, this.statics.blotName, this.statics.formats(this.domNode));
    }
  }, {
    key: 'replace',
    value: function replace(target) {
      if (target.statics.blotName !== this.statics.blotName) {
        var item = Parchment.create(this.statics.defaultChild);
        target.moveChildren(item);
        this.appendChild(item);
      }
      if (target.parent == null) return;
      __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(ContainBlot.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ContainBlot.prototype), 'replace', this).call(this, target);
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var tagName = 'contain';
      var node = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(ContainBlot.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ContainBlot), 'create', this).call(this, tagName);
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return domNode.tagName;
    }
  }]);

  return ContainBlot;
}(Container);

ContainBlot.blotName = 'contain';
ContainBlot.tagName = 'contain';
ContainBlot.scope = Parchment.Scope.BLOCK_BLOT;
ContainBlot.defaultChild = 'block';
ContainBlot.allowedChildren = [Block, BlockEmbed, Container];
window.Quill.register(ContainBlot);

var TableRow = function (_Container2) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(TableRow, _Container2);

  function TableRow() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, TableRow);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableRow.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(TableRow)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(TableRow, [{
    key: 'optimize',
    value: function optimize() {
      __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(TableRow.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(TableRow.prototype), 'optimize', this).call(this);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('rowId') === this.domNode.getAttribute('rowId')) {
        next.moveChildren(this);
        next.remove();
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var tagName = 'tr';
      var node = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(TableRow.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(TableRow), 'create', this).call(this, tagName);
      node.setAttribute('rowId', value);
      return node;
    }
  }]);

  return TableRow;
}(Container);

TableRow.blotName = 'tr';
TableRow.tagName = 'tr';
TableRow.scope = Parchment.Scope.BLOCK_BLOT;
TableRow.defaultChild = 'td';
window.Quill.register(TableRow);

var TableTrick = function () {
  function TableTrick() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, TableTrick);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(TableTrick, null, [{
    key: 'randomId',
    value: function randomId() {
      return Math.random().toString(36).slice(2);
    }
  }, {
    key: 'findTd',
    value: function findTd(what) {
      var leaf = quill.getLeaf(quill.getSelection()['index']);
      var blot = leaf[0];
      for (; blot != null && blot.statics.blotName !== what;) {
        blot = blot.parent;
      }
      return blot;
    }
  }, {
    key: 'appendCol',
    value: function appendCol() {
      var td = TableTrick.findTd('td');
      if (td) {
        var table = td.parent.parent;
        var tableId = table.domNode.getAttribute('tableId');
        td.parent.parent.children.forEach(function (tr) {
          var rowId = tr.domNode.getAttribute('rowId');
          var cellId = TableTrick.randomId();
          var td = Parchment.create('td', tableId + '|' + rowId + '|' + cellId);
          tr.appendChild(td);
        });
      }
    }
  }, {
    key: 'appendRow',
    value: function appendRow() {
      var td = TableTrick.findTd('td');
      if (td) {
        var colCount = td.parent.children.length;
        var table = td.parent.parent;
        var newRow = td.parent.clone();
        var tableId = table.domNode.getAttribute('tableId');
        var rowId = TableTrick.randomId();
        newRow.domNode.setAttribute('rowId', rowId);
        for (var i = colCount - 1; i >= 0; i--) {
          var cellId = TableTrick.randomId();
          var _td2 = Parchment.create('td', tableId + '|' + rowId + '|' + cellId);
          newRow.appendChild(_td2);
        }
        table.appendChild(newRow);
      }
    }
  }, {
    key: 'removeRow',
    value: function removeRow() {
      var td = TableTrick.findTd('td');
      if (td) {
        var tr = td.parent;
        tr.remove();
      }
    }
  }, {
    key: 'removeCol',
    value: function removeCol() {
      var td = TableTrick.findTd('td');
      if (td) {
        var table = td.parent.parent;
        var cellId = td.domNode.getAttribute('cell_id');
        var colIndex = 1;

        td.parent.children.forEach(function loop(_td) {
          if (_td.domNode.getAttribute('cell_id') === cellId) {
            loop.stop = true;
            return;
          }

          if (!loop.stop) {
            colIndex += 1;
          }
        });

        table.children.forEach(function (tr) {
          var _td = tr.children.find(colIndex)[0];
          if (_td) {
            _td.remove();
          }
        });
      }
    }
  }, {
    key: 'removeTable',
    value: function removeTable() {
      var td = TableTrick.findTd('td');
      if (td) {
        var table = td.parent.parent;
        table.remove();
      }
    }
  }, {
    key: 'cellBackground',
    value: function cellBackground(color) {
      var td = TableTrick.findTd('td');
      if (td) {
        var style = 'background:' + color;
        td.format('style', color ? style : false);
      }
    }
  }]);

  return TableTrick;
}();

var Table = function (_Container3) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Table, _Container3);

  function Table() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Table);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Table.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Table)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Table, [{
    key: 'optimize',
    value: function optimize() {
      __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(Table.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Table.prototype), 'optimize', this).call(this);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('tableId') === this.domNode.getAttribute('tableId')) {
        next.moveChildren(this);
        next.remove();
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      if (value === 'append-row') {
        var blot = TableTrick.appendRow();
        return blot;
      } else if (value === 'append-col') {
        var _blot = TableTrick.appendCol();
        return _blot;
      } else if (value.includes('newtable_')) {
        var _node = null;
        var sizes = value.split('_');
        var rowCount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(sizes[1]);
        var colCount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(sizes[2]);
        var tableId = TableTrick.randomId();
        var table = Parchment.create('table', tableId);
        for (var ri = 0; ri < rowCount; ri++) {
          var rowId = TableTrick.randomId();
          var tr = Parchment.create('tr', rowId);
          table.appendChild(tr);
          for (var ci = 0; ci < colCount; ci++) {
            var cellId = TableTrick.randomId();
            value = tableId + '|' + rowId + '|' + cellId;
            var td = Parchment.create('td', value);
            tr.appendChild(td);
            var p = Parchment.create('block');
            td.appendChild(p);
            var br = Parchment.create('break');
            p.appendChild(br);
            _node = p;
          }
        }
        var leaf = quill.getLeaf(quill.getSelection()['index']);
        var _blot2 = leaf[0];
        var topBranch = null;
        for (; _blot2 != null && !(_blot2 instanceof Container || _blot2 instanceof Scroll);) {
          topBranch = _blot2;
          _blot2 = _blot2.parent;
        }
        _blot2.insertBefore(table, topBranch);
        return _node;
      } else {
        if (value === 'remove-row') {
          TableTrick.removeRow();
          return _node2;
        }
        if (value === 'remove-col') {
          TableTrick.removeCol();
          return _node2;
        }
        if (value === 'remove-table') {
          TableTrick.removeTable();
          return _node2;
        }
        if (value === 'cell-background') {
          var bgColor = prompt('Background color?');
          TableTrick.cellBackground(bgColor);
          return _node2;
        }

        var tagName = 'table';
        var _node2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(Table.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Table), 'create', this).call(this, tagName);
        _node2.setAttribute('tableId', value);
        return _node2;
      }
    }
  }]);

  return Table;
}(Container);

Table.blotName = 'table';
Table.tagName = 'table';
Table.scope = Parchment.Scope.BLOCK_BLOT;
Table.defaultChild = 'tr';
Table.allowedChildren = [TableRow];
window.Quill.register(Table);

var TableCell = function (_ContainBlot) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(TableCell, _ContainBlot);

  function TableCell() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, TableCell);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableCell.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(TableCell)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(TableCell, [{
    key: 'format',
    value: function format(key, value) {
      this.domNode.setAttribute(key, value);
    }
  }, {
    key: 'formats',
    value: function formats() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, this.statics.blotName, this.domNode.getAttribute('tableId') + '|' + this.domNode.getAttribute('rowId') + '|' + this.domNode.getAttribute('cellId') + '|' + this.domNode.getAttribute('style'));
    }
  }, {
    key: 'optimize',
    value: function optimize() {
      __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(TableCell.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(TableCell.prototype), 'optimize', this).call(this);

      var parent = this.parent;
      if (parent != null && parent.statics.blotName !== 'tr') {
        var mark = Parchment.create('block');
        this.parent.insertBefore(mark, this.next);
        var table = Parchment.create('table', this.domNode.getAttribute('tableId'));
        var tr = Parchment.create('tr', this.domNode.getAttribute('rowId'));
        table.appendChild(tr);
        tr.appendChild(this);
        table.replace(mark);
      }

      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('cellId') === this.domNode.getAttribute('cellId')) {
        next.moveChildren(this);
        next.remove();
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var tagName = 'td';
      var node = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(TableCell.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(TableCell), 'create', this).call(this, tagName);
      var ids = value.split('|');
      node.setAttribute('tableId', ids[0]);
      node.setAttribute('rowId', ids[1]);
      node.setAttribute('cellId', ids[2]);
      node.setAttribute('style', ids[3] || '');
      return node;
    }
  }]);

  return TableCell;
}(ContainBlot);

TableCell.blotName = 'td';
TableCell.tagName = 'td';
TableCell.scope = Parchment.Scope.BLOCK_BLOT;
TableCell.defaultChild = 'block';
TableCell.allowedChildren = [Block, BlockEmbed, Container];
window.Quill.register(TableCell);
TableRow.allowedChildren = [TableCell];

Container.order = ['list', 'contain', 'td', 'tr', 'table'];

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(245)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(250),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[149]);


// WEBPACK FOOTER //
// static/js/app.d656af1fc0e4da1acff9.js